export const FormFilterDataTypeEnum = {
  MONTH: "month"
};

export const ListCategory = {
  FAQ: "faq",
  JOBS: "jobs"
};
